import { Button } from "@design-system/Button/Button";

interface ClearFiltersButtonProps {
    onClick: () => void;
}

/** The filter bar's Clear filters action, sized to match the Filter button and pills. */
export const ClearFiltersButton = ({ onClick }: ClearFiltersButtonProps) => (
    <Button
        variant="secondary"
        size="md"
        onClick={onClick}
        data-testid="clear-filters-button"
    >
        Clear filters
    </Button>
);
